import { Observable } from 'rxjs';
import { get, post } from '@/shared/api/http';

const BASE_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:8000';
const TOKEN_KEY = 'auth_token';

interface GeoJsonPoint {
  type: 'Point';
  coordinates: [number, number]; // [lng, lat]
}

interface GeoJsonPolygon {
  type: 'Polygon';
  coordinates: [number, number][][];
}

interface GeoJsonMultiPoint {
  type: 'MultiPoint';
  coordinates: [number, number][]; // [lng, lat][]
}

export interface FlightNotification {
  id: string;
  operator: number;
  device: number;
  flight_date: string;
  time_from: string;
  time_to: string;
  location_name: string;
  category: number;
  status: 'draft' | 'submitted';
  purpose: string;
  submitted_at: string | null;
  created_at: string;
  takeoff_point: GeoJsonPoint | null;
  additional_takeoff_points: GeoJsonMultiPoint | null;
  flight_area: GeoJsonPolygon | null;
  buffer_zone: GeoJsonPolygon | null;
  termination_zone: GeoJsonPolygon | null;
  buffer_zone_meters: number | null;
  termination_zone_meters: number | null;
  planned_altitude_m: number;
  max_distance_m: number;
}

export function getFlightNotifications(): Observable<FlightNotification[]> {
  return get<FlightNotification[]>('/api/v1/flights/notifications/');
}


export function downloadFlightFile(id: string, type: 'pdf' | 'kml',generate:boolean): void {
  const token = localStorage.getItem(TOKEN_KEY);
  let url = `${BASE_URL}/api/v1/flights/notifications/${id}/download-${type}/`;

  if(generate){
    url = `${BASE_URL}/api/v1/flights/notifications/${id}/generate-${type}/`;

  }

  fetch(url, { headers: token ? { Authorization: `Bearer ${token}` } : {} })
    .then(res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.blob();
    })
    .then(blob => {
      const filename = type === 'pdf'
        ? `UAS_najava_leta_${id}.pdf`
        : `UAS_obmocje_letenja_${id}.kml`;
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = objectUrl;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(objectUrl);
    })
    .catch(console.error);
}

export function downloadDsmTif(id: string): void {
  const token = localStorage.getItem(TOKEN_KEY);
  const url = `${BASE_URL}/api/v1/flights/notifications/${id}/download-dsm-tif/`;
  fetch(url, { headers: token ? { Authorization: `Bearer ${token}` } : {} })
    .then(res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.blob();
    })
    .then(blob => {
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = objectUrl;
      a.download = `dsm_${id}.tif`;
      a.click();
      URL.revokeObjectURL(objectUrl);
    })
    .catch(console.error);
}

export function sendFlightNotification(id: string): Observable<{ detail: string }> {
  console.log("sending notification")
  return post<{ detail: string }>(`/api/v1/flights/notifications/${id}/send/`, {})
}
